import React, { Component } from "react";
import styled from "styled-components";
import Geocode from "react-geocode";
import GoogleMap from "../GoogleMap/GoogleMap.js";

Geocode.setApiKey("AIzaSyBdTtuiGTPtv3nE31khxrOBdBg2OylWcro");

const Wrapper = styled.div``;

const validPostalCodeRegex = RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/);
const validateForm = errors => {
  let valid = true;
  Object.values(errors).forEach(val => val.length > 0 && (valid = false));
  return valid;
};

const countErrors = errors => {
  let count = 0;
  Object.values(errors).forEach(val => val.length > 0 && (count = count + 1));
  return count;
};

var coordinates = [];
class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.clearSearchBox = this.clearSearchBox.bind(this);
    this.state = {
      formValid: false,
      errorCount: null,
      errors: {
        postalCode: ""
      }
    };
  }

  handleChange = event => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;
    switch (name) {
      case "postalCode":
        errors.postalCode = validPostalCodeRegex.test(value)
          ? ""
          : "Postal Code is not valid!";
        break;
    }

    this.setState({ errors, [name]: value });
  };

  handleSubmit = event => {
    event.preventDefault();
    // console.log(coordinates);
    this.setState({ formValid: validateForm(this.state.errors) });
    this.setState({ errorCount: countErrors(this.state.errors) });
    if (validateForm(this.state.errors)) {
      Geocode.fromAddress(this.searchInput.value).then(
        response => {
          const { lat, lng } = response.results[0].geometry.location;
          this.props.updateLocation(lat, lng);
        },
        error => {
          console.error(error);
        }
      );
    }
  };

  componentDidMount({ map, mapApi } = this.props) {
    // this.searchBox = new mapApi.places.SearchBox(this.searchInput);
  }

  componentWillUnmount({ mapApi } = this.props) {
    //mapApi.event.clearInstanceListeners(this.searchInput);
  }

  onPlacesChanged = ({ map, addplace } = this.props) => {
    const selected = this.searchBox.getPlaces();
    const { 0: place } = selected;
    if (!place.geometry) return;
    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(17);
    }

    addplace(selected);
    this.searchInput.blur();
  };

  clearSearchBox() {
    this.searchInput.value = "";
  }

  render() {
    const { errors, formValid } = this.state;
    return (
      <Wrapper>
        <form onSubmit={this.handleSubmit} noValidate>
          <input
            ref={ref => {
              this.searchInput = ref;
            }}
            name="searchBox"
            className="search-box"
            type="text"
            onFocus={this.clearSearchBox}
            onChange={this.handleChange}
            noValidate
            autoComplete="off"
            placeholder="Rechercher par code postal ou par ville"
          />
          {errors.postalCode.length > 0 && (
            <div className="error">{errors.postalCode}</div>
          )}
        </form>
      </Wrapper>
    );
  }
}

export default SearchBox;
